export default {
    data() {
        return {
            valid: {
                events: false,
                url: false,
            },
            success: {
                events: false,
                url: false,
            },
            error: {
                events: "",
                url: "",
            },
            errorMessages: {
                eventRequired: {
                    el: "Απαιτείται τουλαχιστον ένα συμβάν",
                    en: "At least one event is required",
                    it: "È richiesto almeno un evento"
                },
                urlRequired: {
                    el: "Απαιτείται διεύθυνση URL",
                    en: "URL is required",
                    it: "L'URL è richiesto"
                },
                urlInvalid: {
                    el: "Μη έγκυρη διεύθυνση URL",
                    en: "Invalid URL",
                    it: "URL non valido"
                },
                urlExists: {
                    el: "Η διεύθυνση URL υπάρχει ήδη",
                    en: "URL already exists",
                    it: "L'URL esiste già"
                },
            }
        };
    },

    computed: {
        formValid() {
            return this.valid.url && this.valid.events ;
        },
        allUrls(){
            return this.webhooks.map(e => {
                if (e.store_event_id != this.webhookData.store_event_id) {
                    return e.endpoint_url
                }
            })
        }
    },

    methods: {
        resetValidation(){
            this.valid = {
                events: false,
                url: false,
            };
            this.success = {
                events: false,
                url: false,
            };
            this.error = {
                events: "",
                url: "",
            };

        },
        
        validateEvents() {
            if (!this.webhookData.event_types?.length ) {
                    this.error.events = this.errorMessages.eventRequired[
                        this.lang
                    ];
            } else {
                this.error.events = "";
            }
        },
     
        isValidURL(url) {
            try {
                return Boolean(new URL(url));
            } catch (e) {
                return false;
            }
        },

        validateUrl() {
            this.error.url = "";
            if (!this.webhookData.endpoint_url){
               this.error.url = this.errorMessages.urlRequired[this.lang];
            } else 
            if (!this.isValidURL(this.webhookData.endpoint_url)){
                this.error.url = this.errorMessages.urlInvalid[this.lang];
            } else 
            if (this.allUrls.includes(this.webhookData.endpoint_url)){
                this.error.url = this.errorMessages.urlExists[this.lang];
            }
            this.valid.url = true;
            return this.error.url == "";

        },
    },

    watch: {
      
        ["webhookData.event_types"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.events = val.length > 0;
                    this.success.events = val.length > 0;
                }
            },
            deep: true
        },

        ["webhookData.endpoint_url"]: {
            immediate: true,
            handler(val) {
                if (this.validateUrl()) {
                    this.valid.url = true;
                    this.success.url = val && true;
                } else {
                    this.success.url = false;
                    this.valid.url = false;
                }
            }
        },


        resetSuccess(val) {
            if (val) {
                this.success = {
                    events: false,
                    url: false,
                };
                this.setResetSuccess(false);
            }
        },

      
    }
};
